import { render, staticRenderFns } from "./Interpersonal.vue?vue&type=template&id=57552098&scoped=true&"
import script from "./Interpersonal.vue?vue&type=script&lang=js&"
export * from "./Interpersonal.vue?vue&type=script&lang=js&"
import style0 from "./Interpersonal.vue?vue&type=style&index=0&id=57552098&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57552098",
  null
  
)

export default component.exports